import React from "react";
import NavBar from "../../NavBar"
import Footer from "../../Footer"
import datiBigiotteria from "../../../data/bigiotteriaProdotti.json";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from "react";
import ScrollabileRiga from "../ScrollabileRiga";
import Selezione from "../Selezione"

export default function Orecchini(){

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    function tornaSopra(){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
    }
    useEffect(() => {
            window.addEventListener("scroll",(e)=>{
            const bottone = document.getElementById("btnTop");
            if(window.scrollY===0){
                try {
                    bottone.classList.add("invisibile");
                } catch (error) {
                    return null;
                }
                
                
                setTimeout(() => {
                    try {
                        bottone.classList.add("invisibilePerDavvero")
                    } catch (error) {
                        return null;
                    }
                    
                }, "490");
                try {
                    bottone.classList.remove("visibile");
                } catch (error) {
                    return null;
                }
                
            }else{
                try {
                    bottone.classList.remove("invisibile");
                    bottone.classList.remove("invisibilePerDavvero");
                    bottone.classList.add("visibile");
                } catch (error) {
                    return null;
                }
                
            }
            
        });
        
    });
    
    const arrId = ["In Generale","Classici","Pendente","Eleganti","Finti","Calamita"]    
    return (
        <div className="bigiotteriaBody wuXieKeJi">
            <button id="btnTop" onClick={()=>tornaSopra()}><FontAwesomeIcon icon={faArrowUp} /></button>
            <NavBar uno ="Prodotti" due="Informazioni" tre="Contattaci" one="/prodotti" two="/informazioni" three="/contattaci"/>
            <h1 className="titoloProdotti">Orecchini</h1>
            <Selezione arr={arrId}/>

            <div className="premessaProdotti">
                <p>A causa di un ecessivo numero di orecchini, qui mostriamo in dettaglio solo alcuni modelli.</p>
            </div>
            
            <div className="colonna bigiotteria">

                <ScrollabileRiga idTitolo="InGenerale" titolo="In Generale" idScroll1="1" idScroll2="2" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="overView3" sottoTipo2="overView4" nomeDati="bigiotteriaProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Classici" titolo="Classici" idScroll1="3" idScroll2="4" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="o1" sottoTipo2="o2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Pendente" titolo="Pendente" idScroll1="5" idScroll2="6" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="p1" sottoTipo2="p2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Eleganti" titolo="Eleganti" idScroll1="7" idScroll2="8" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="el1" sottoTipo2="el2" nomeDati="bigiotteriaProdotti"/>

                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Finti" titolo="Finti" idScroll1="9" idScroll2="10" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="fi1" sottoTipo2="fi2" nomeDati="bigiotteriaProdotti"/>
                
                <hr className="separatore"/>

                <ScrollabileRiga idTitolo="Calamita" titolo="Calamita" idScroll1="11" idScroll2="12" dati={datiBigiotteria} tipo="orecchini" sottoTipo1="ca1" sottoTipo2="ca2" nomeDati="bigiotteriaProdotti"/>
                

            </div>
            <Footer />
        </div>
    )
}